"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wizard = exports.validator = void 0;
var validator = ["NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"];
exports.validator = validator;
var wizard = ['New South Wales', 'Northern Territory', 'Queensland', 'South Australia', 'Tasmania', 'Victoria', 'Western Australia'];
exports.wizard = wizard;
//# sourceMappingURL=states_AU.js.map